import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../providers/AuthProvider';
import TalentPortal from '../../../talent-portal/TalentPortal';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import DashboardCard, { LastUpdatedPill } from './DashboardCard';

/**
 * Jobs card for the new talent dashboard.
 * Functional / Tailwind port of JobsPreferencesPanel.
 */

const daysSince = (date) => {
    if (!date || !TB.moment(date).isValid()) return null;
    return Math.max(0, TB.moment().diff(TB.moment(date), 'days'));
};

const JobStat = ({ value, label, state }) => (
    <Link
        to={TalentPortal.jobBoardPath()}
        state={state}
        className="flex min-w-0 flex-col items-center justify-center rounded-xl border border-solid border-gray-200 bg-white px-2 py-3 text-center hover:border-primary/40 hover:bg-primary/5 hover:no-underline"
    >
        <span className="text-2xl font-bold leading-tight text-primary sm:text-3xl">{parseInt(value) || 0}</span>
        <span className="mt-0.5 text-sm text-gray-600">{label}</span>
    </Link>
);

const JobsCard = ({ stats, className, disabledReason }) => {
    const { auth } = useAuth();
    const isDisabled = !auth?.isProfileApproved?.();

    return (
        <DashboardCard
            title="Jobs"
            count={stats?.total_new_open_positions}
            className={className}
            disabled={isDisabled}
            disabledReason={disabledReason}
            headerRight={<LastUpdatedPill prefix="" days={daysSince(stats?.last_viewed_talent_open_positions)} />}
            footer={(
                <Link
                    to={TalentPortal.jobBoardPath()}
                    className="ml-auto inline-flex items-center justify-center whitespace-nowrap rounded-lg bg-primary px-5 py-2.5 text-xs font-semibold text-white hover:bg-primary-dark hover:text-white hover:no-underline"
                >
                    View jobs
                </Link>
            )}
        >
            {stats ? (
                <div className="grid grid-cols-3 gap-2 sm:gap-3">
                    <JobStat value={stats.total_open_positions} label="Jobs" state={{ only_matching: 0 }} />
                    <JobStat value={stats.total_matching_open_positions} label="Matches" state={{ only_matching: 1 }} />
                    <JobStat value={stats.total_new_matching_open_positions} label="New" />
                </div>
            ) : (
                <div className="flex min-h-[88px] items-center justify-center">
                    <LoadingSpinner size="lg" />
                </div>
            )}
        </DashboardCard>
    );
};

JobsCard.propTypes = {
    stats: PropTypes.object,
    className: PropTypes.string,
    disabledReason: PropTypes.node,
};

export default JobsCard;
